module.exports = __webpack_public_path__ + "img/Wp_2044.c311d252.png";